import angular from "angular"

const service = [
  "$http",
  "store",
  function($http, store) {
    var self = this

    // self.baseUrl = 'http://localhost/retention_manager_upv/';
    // self.baseUrl = 'http://localhost:3000/';
    self.baseUrl = "http://localhost:3003/"

    self.urlForListaAlumnos = self.baseUrl + "get_lista_alumnos/"

    self.getAlumnos = function(params) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_alumnos/",
        params: params
      }).then(function(response) {
        return response.data
      })
    }

    self.getResponsables = function() {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_responsables/"
      }).then(function(response) {
        return response.data
      })
    }

    self.getAlumno = function(alumno_id) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_alumno/" + alumno_id + "/"
      }).then(function(response) {
        return response.data
      })
    }

    self.getAccionesAlumno = function(alumno_id) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_acciones_alumno/" + alumno_id + "/"
      }).then(function(response) {
        return response.data
      })
    }

    self.getAccionesRetencion = function() {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_acciones_retencion/"
      }).then(function successCallback(response) {
        return response.data
      })
    }

    self.postAtencion = function(args, successCallback) {
      var data = {
        alumno_id: args["alumnoId"]
      }

      Object.assign(data, args["data"])

      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "post_acciones_alumno/",
        data: $.param(data)
      }).then(function(response) {
        if (successCallback) {
          successCallback()
        }
        return response.data
      })
    }

    //recibe un arreglo de id's de eventos
    self.deleteAtenciones = function(data) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "delete_acciones_alumno/",
        data: $.param(data)
      }).then(function(response) {
        return response.data
      })
    }

    self.deleteAlertas = function(data) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "delete_alertas_alumno/",
        data: $.param(data)
      }).then(function(response) {
        return response.data
      })
    }

    self.updateAtenciones = function(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "update_acciones_alumno/",
        data: $.param({ models: JSON.stringify(models) })
      }).then(function(response) {
        return response.data
      })
    }

    //Alertas

    self.postAlerta = function(args, successCallback) {
      var data = {
        alumno_id: args["alumnoId"]
      }

      Object.assign(data, args["data"])

      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "post_alerta_alumno/",
        data: $.param(data)
      }).then(function(response) {
        if (successCallback) {
          successCallback()
        }
        return response.data
      })
    }

    self.getAlertasAlumno = function(alumno_id) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_alertas_alumno/" + alumno_id + "/"
      }).then(function successCallback(response) {
        return response.data
      })
    }

    self.getTipoAlertas = function() {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_tipo_alertas/"
      }).then(function(response) {
        return response.data
      })
    }

    self.getEstadoAlertas = function() {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_estado_alertas/"
      }).then(function(response) {
        return response.data
      })
    }

    self.getAlertasAlumnoIndicadores = function(alumno_id) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_acciones_retencion/"
      }).then(function successCallback(response) {
        return {
          activas: {
            type: "number",
            class: "system",
            title: "Alerta Activa",
            value: 1
          },
          atendidas: {
            type: "number",
            class: "system",
            title: "Alerta en Atención",
            value: 1
          },
          cerradas: {
            type: "number",
            class: "system",
            title: "Alertas Cerradas",
            value: 2
          }
        }
      })
    }

    self.updateAlertas = function(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "update_alertas_alumno/",
        data: $.param({ models: JSON.stringify(models) })
      }).then(function(response) {
        return response.data
      })
    }

    self.updateAlumno = function(data) {
      console.log(data)
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: self.baseUrl + "update_antecedentes_alumno/",
        data: $.param({ data: JSON.stringify(data) })
      }).then(function(response) {
        return response.data
      })
    }

    self.getListaAlumnos = function() {
      return $http({
        method: "GET",
        url: self.urlForListaAlumnos
      }).then(function(response) {
        return response.data
      })
    }

    //recibe params
    self.getListaAlumnosServerSide = function(params) {
      console.log(params)
      return $http({
        method: "GET",
        url: self.baseUrl + "get_lista_alumnos_server_side/",
        params: params
      }).then(function(response) {
        return response.data
      })
    }

    self.getEstadoMatriculas = function() {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_estado_matriculas/"
      }).then(function(response) {
        return response.data
      })
    }

    self.importAtenciones = function(args) {
      var data = []
      var total_alumnos = args.alumnos.length
      var alumno
      for (var i = 0; i < total_alumnos; i++) {
        alumno = {
          alumno_id: args.alumnos[i]
        }
        Object.assign(alumno, args["data"])

        data.push(alumno)
      }

      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: self.baseUrl + "import_acciones_alumno/",
        data: JSON.stringify({ "atenciones[]": data })
      }).then(function(response) {
        return response.data
      })
    }

    self.importAlertas = function(args) {
      var data = []
      var total_alumnos = args.alumnos.length
      var alumno
      for (var i = 0; i < total_alumnos; i++) {
        alumno = {
          alumno_id: args.alumnos[i]
        }
        Object.assign(alumno, args["data"])

        data.push(alumno)
      }

      console.log("import alertas masiva:", data)

      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: self.baseUrl + "import_alertas_alumno/",
        data: JSON.stringify({ "alertas[]": data })
      }).then(function(response) {
        return response.data
      })
    }

    self.importEstadoMatricula = function(args) {
      console.log("import estado matrículas masivo:", args)
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: self.baseUrl + "import_estado_matricula/",
        data: JSON.stringify({
          "alumnos[]": args.alumnos,
          estado_id: args.data.estado_matricula_id
        })
      }).then(function(response) {
        return response.data
      })
    }

    self.getComentarios = function(args) {
      return $http({
        method: "GET",
        url: self.baseUrl + "get_comentarios/",
        params: args
      }).then(function(response) {
        return response.data
      })
    }

    self.postComentario = function(data) {
      data["username"] = store.get("user").username
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: self.baseUrl + "post_comentario/",
        data: JSON.stringify(data)
      }).then(function(response) {
        return response.data
      })
    }

    self.deleteComentarios = function(models) {
      return $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: self.baseUrl + "delete_comentario/",
        data: JSON.stringify(models)
      }).then(function(response) {
        return response.data
      })
    }

    return {
      getAlumnos: self.getAlumnos,
      getAlumno: self.getAlumno,
      getResponsables: self.getResponsables,
      getAtenciones: self.getAccionesAlumno,
      getAccionesRetencion: self.getAccionesRetencion,
      getAlertas: self.getAlertasAlumno,
      getAlertasIndicadores: self.getAlertasAlumnoIndicadores,
      postAtencion: self.postAtencion,
      postAlerta: self.postAlerta,
      deleteAtenciones: self.deleteAtenciones,
      deleteAlertas: self.deleteAlertas,
      updateAtenciones: self.updateAtenciones,
      getTipoAlertas: self.getTipoAlertas,
      getEstadoAlertas: self.getEstadoAlertas,
      updateAlertas: self.updateAlertas,
      updateAlumno: self.updateAlumno,
      getListaAlumnos: self.getListaAlumnos,

      urlForListaAlumnos: self.urlForListaAlumnos,

      getListaAlumnosServerSide: self.getListaAlumnosServerSide,

      getEstadoMatriculas: self.getEstadoMatriculas,

      baseUrl: self.baseUrl,

      importAtenciones: self.importAtenciones,
      importAlertas: self.importAlertas,
      importEstadoMatricula: self.importEstadoMatricula,

      getComentarios: self.getComentarios,
      postComentario: self.postComentario,
      deleteComentarios: self.deleteComentarios
    }
  }
]

angular.module("appModule").service("fichaAlumnoService", service)
